const isHourInUse = ({start, finish}, hour) => {
  if (start > finish) {
    return hour >= start || hour < finish;
  }
  return hour >= start && hour < finish;
};

export default isHourInUse;
